import React, { useState, useEffect } from "react";
import "../css/Tiltop.css"; 

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Viser knappen, når man scroller ned
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll tilbage til toppen
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <button onClick={scrollToTop} className="btn">
          ⬆ Til Top
        </button>
      )}
    </div>
  );
};

export default ScrollToTop;